<div class="profile-page">
    <div class="wrapper">
        <div class="page-header page-header-small" filter-color="orange">
            <div class="page-header-image" data-parallax="true" style="background-image: url('assets/images/introduction.jpg');">
            </div>
        <div class="container">
            <div class="content-center">
                <div class="profile-image">
                    <a href="#">
                        <img src="assets/images/profile6.PNG" alt="Image" />
                    </a>
                </div>
                <div class="h2 title">Vamshi Kumar Konduru </div>
                <p class="category text-white">Sr Software Engineer | Sr Full Stack Dev</p>
                <a class="btn btn-primary smooth-scroll mr-2" href="#contact" data-aos="zoom-in" data-aos-anchor="data-aos-anchor">Let's Connect</a>
                <a class="btn btn-primary"href="https://drive.google.com/file/d/16AigKA8WZw_FiRMvI4S0QJ2F7YEhHlae/view?usp=sharing" target="_blank" data-aos="zoom-in" data-aos-anchor="data-aos-anchor">Download Resume</a>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="button-container">
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.facebook.com/vamshi.rockzz.581/" target="_blank" rel="tooltip" title="Follow me on Facebook">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.instagram.com/iam_vamshi564/" target="_blank" rel="tooltip" title="Follow me on Instagram">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="www.linkedin.com/in/vamshi-kumar-21b298115" target="_blank" rel="tooltip" title="Follow me on Linkedin">
                        <i class="fa fa-linkedin"></i>
                    </a>
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/Vam564" target="_blank" rel="tooltip" title="Follow me on Github">
                        <i class="fa fa-github"></i>
                    </a>
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://twitter.com/IVamshi564" target="_blank" rel="tooltip" title="Follow me on Twitter">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="#" target="_blank" rel="tooltip" title="Follow me on Google+">
                        <i class="fa fa-google-plus"></i>
                    </a>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
